import {
  disableEmployee,
  EmployeesSliceState,
  enableEmployee,
  selectEmployees,
  updateEmployee,
} from "app/redux/employeesSlice";
import { selectShops } from "app/redux/shopsSlice";
import { useQuery } from "app/utils/useQuery";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { uploadFile } from "../../utils/upload";
import { UserAuth } from "app/context/AuthContext";

export const useStaffDetails = ({
  selectedEmployee,
}: {
  selectedEmployee: EmployeesSliceState;
}) => {
  const { impersonate } = UserAuth();
  const dispatch = useDispatch();
  const query = useQuery();
  const employees = useSelector(selectEmployees);
  const existingShops = useSelector(selectShops);
  const [employeeShops, setEmployeeShops] = useState<any[]>([]);
  const navigate = useNavigate();

  const onEmployeeUpdate = async (data: any) => {
    try {
      const newEmployee = await dispatch(
        updateEmployee({
          ...data,
          id: selectedEmployee.id,
        }) as any
      ).unwrap();
      toast.success(`${newEmployee.name} was updated successfully`);
    } catch (error) {
      toast.error("Failed to update employee");
      console.log(error);
    }
  };
  //
  // const handleShopSelectionChange = (selectedOptions: any) => {
  //   if (selectedEmployee) {
  //     const selectedShopIds = selectedOptions.map(
  //       (option: any) => option.value
  //     );
  //
  //     const updatedEmployee = {
  //       id: selectedEmployee.id,
  //       shopIds: selectedShopIds,
  //     };
  //
  //     // Update the employee and notify
  //     onEmployeeUpdate(updatedEmployee);
  //   }
  // };


  const handleShopSelectionChange = (toggledShop:any, isChecked:boolean) => {
    if (!selectedEmployee) return;
    const currentShops = selectedEmployee.shops || [];
    const newShopsArray = isChecked
        ? [...currentShops, toggledShop]
        : currentShops.filter((shop:any) => shop.id !== toggledShop.id);
    // setSelectedEmployee((prev:any) => (prev ? { ...prev, shops: newShopsArray } : null));

    const newShopIds = newShopsArray.map((shop:any) => shop.id);

    const updatedEmployeePayload = {
      id: selectedEmployee.id,
      shopIds: newShopIds,
    };

    onEmployeeUpdate(updatedEmployeePayload);
  };


  const handleAvatarUpload = async (
      // event: React.ChangeEvent<HTMLInputElement>
      file: File
  ) => {
    const imageUrl = await uploadFile(file, "employee/profile");
    return (imageUrl as any).url
  };


  const handleAvatarChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      // const formData = new FormData();
      // formData.append("employee[avatar]", file);
      // formData.append("employee[id]", selectedEmployee.id.toString());

      try {

       const url= await handleAvatarUpload(file)
        if (url) {
          await dispatch(
              updateEmployee({
                id: selectedEmployee.id.toString(),
                avatar: url,
              }) as any
          ).unwrap();
        }
        else {
          toast.error("Failed to upload avatar");
          return
        }

        toast.success("Avatar updated successfully");
      } catch (error) {
        console.log("error", error);
        toast.error("Failed to update avatar");
      }
    }
  };

  const onDisableEmployee = async (selectedEmployee:{
    name:string,id:any
  }) => {
    const shouldRemoveEmployee = window.confirm(
      `Are you sure you want to remove ${selectedEmployee.name}? Doing so will erase all ${selectedEmployee.name}'s future bookings.`
    );

    if (!shouldRemoveEmployee) {
      return;
    }

    try {
      await dispatch(disableEmployee(selectedEmployee.id) as any).unwrap();
      const setNewEmployee = employees[0];
      query.set("employeeId", setNewEmployee.id.toString());
      navigate(`?${query.toString()}`);
      toast.success("Employee disabled successfully");
    } catch (error) {
      console.log("error", error);
    }
  };

  const onReenableEmployee = async () => {
    try {
      await dispatch(enableEmployee(selectedEmployee.id) as any).unwrap();
      toast.success("Employee reenabled successfully");
    } catch (error) {
      console.log("error", error);
    }
  };

  const onImpersonate = async () => {
    try {
      await impersonate(selectedEmployee.id);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const defaultShopSelectValue =
      selectedEmployee?.shops?.map((shop: any) => ({
        value: shop.id,
        label: shop.name,
      })) || [];

    setEmployeeShops(defaultShopSelectValue);
  }, [selectedEmployee]);

  return {
    employees,
    selectedEmployee,
    onEmployeeUpdate,
    existingShops,
    handleShopSelectionChange,
    employeeShops,
    handleAvatarChange,
    onDisableEmployee,
    onReenableEmployee,
    onImpersonate,
  };
};
